import { AdminEconomyService } from "../../../services/admin-economy.service.js";

export const PaymentTab = async (container) => {
    // 1. Initial Render
    container.innerHTML = `
        <div class="space-y-6 animate-fade-in">
            <!-- Header -->
            <div class="flex justify-between items-center bg-white p-4 rounded-xl border border-gray-200 shadow-sm">
                <div>
                    <h3 class="text-xl font-bold text-indigo-900 flex items-center gap-2">
                        <span class="material-symbols-outlined">payments</span>
                        결제 및 경제 관리 (Payment & Economy)
                    </h3>
                    <p class="text-sm text-gray-500 mt-1">스타 상품, 가격 정책, 그리고 결제 게이트웨이를 설정합니다. (Dynamic Pricing Engine)</p>
                </div>
                <div class="flex gap-2">
                     <button id="refresh-payment-btn" class="px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm font-medium text-gray-600 hover:bg-gray-100 transition-colors">
                        <span class="material-symbols-outlined align-bottom text-sm mr-1">refresh</span> 새로고침
                    </button>
                </div>
            </div>

            <!-- Dashboard Stats (Ticker) -->
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div class="bg-white p-5 rounded-xl border border-gray-200 shadow-sm">
                    <p class="text-xs font-bold uppercase text-gray-400 mb-1">Total Revenue (Today)</p>
                    <p class="text-2xl font-black text-gray-900 font-mono" id="stat-revenue-krw">-</p>
                </div>
                <div class="bg-white p-5 rounded-xl border border-gray-200 shadow-sm">
                    <p class="text-xs font-bold uppercase text-gray-400 mb-1">Stars Minted (Today)</p>
                    <p class="text-2xl font-black text-indigo-600 font-mono" id="stat-minted-stars">-</p>
                </div>
                 <div class="bg-white p-5 rounded-xl border border-gray-200 shadow-sm">
                    <p class="text-xs font-bold uppercase text-gray-400 mb-1">Avg. Bonus Rate</p>
                    <p class="text-2xl font-black text-green-600 font-mono" id="stat-bonus-rate">-</p>
                </div>
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                
                <!-- A. Gateway Configuration -->
                <div class="bg-white p-6 rounded-xl border border-gray-200 shadow-sm relative overflow-hidden">

                    <div class="flex justify-between items-center mb-6 relative z-10">
                        <h4 class="font-bold text-gray-800 flex items-center gap-2">
                            <span class="material-symbols-outlined text-gray-500">settings_ethernet</span>
                            전자 결제 설정 (PG)
                        </h4>
                        <button id="save-pg-btn" class="px-3 py-1.5 bg-indigo-600 text-white text-xs rounded hover:bg-indigo-700 font-bold shadow-sm transition-colors">설정 저장</button>
                    </div>

                    <div class="space-y-4 relative z-10">
                         <div class="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-200">
                            <div>
                                <p class="font-bold text-gray-900 text-sm">결제 모드 (Mode Switch)</p>
                                <p class="text-xs text-gray-500 mt-1" id="pg-mode-desc">안전한 서비스 운영을 위해 <span class="text-indigo-600 font-bold">LIVE 전환 시</span> 비밀키 재입력이 필요합니다.</p>
                            </div>
                            <div class="flex items-center gap-3 bg-white px-4 py-2 rounded-lg border border-gray-200 shadow-sm">
                                <span class="text-xs font-bold text-gray-400" id="label-test">TEST</span>
                                <label class="relative inline-flex items-center cursor-pointer">
                                    <input type="checkbox" id="pg-mode-switch" class="sr-only peer">
                                    <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-red-500 transition-colors"></div>
                                </label>
                                <span class="text-xs font-bold text-gray-400" id="label-live">LIVE</span>
                            </div>
                        </div>
                        
                        <div class="grid grid-cols-2 gap-4">
                            <div>
                                <label class="block text-xs font-bold text-gray-500 uppercase mb-1">Client Key</label>
                                <div class="relative">
                                    <input type="text" id="pg-client-key" class="w-full text-xs border-gray-300 rounded-lg bg-gray-50 text-gray-600 pl-8 focus:ring-indigo-500 focus:border-indigo-500 transition-colors" value="">
                                    <span class="material-symbols-outlined absolute left-2 top-1.5 text-gray-400 text-sm">key</span>
                                </div>
                            </div>
                            <div>
                                <label class="block text-xs font-bold text-gray-500 uppercase mb-1">Secret Key</label>
                                <div class="relative">
                                    <input type="text" id="pg-secret-key" class="w-full text-xs border-gray-300 rounded-lg bg-gray-100 text-gray-400 pl-8 cursor-not-allowed" value="🔒 환경변수로 관리됨 (CLI 전용)" readonly disabled>
                                    <span class="material-symbols-outlined absolute left-2 top-1.5 text-green-500 text-sm">verified_user</span>
                                </div>
                                <p class="text-[10px] text-green-600 mt-1">firebase functions:config:set toss.live_secret_key="live_sk_..."</p>
                            </div>
                        </div>
                    </div>
                        
                        <!-- [NEW] Identity Verification Keys (Optional) -->
                        <div class="mt-4 pt-4 border-t border-gray-100">
                            <h5 class="text-xs font-bold text-gray-500 uppercase mb-2 flex items-center gap-1">
                                <span class="material-symbols-outlined text-sm">badge</span> 본인인증 키 (Optional Identity Key)
                            </h5>
                            <p class="text-[10px] text-gray-400 mb-2">
                                * 별도의 본인인증 계약이 있는 경우에만 입력하세요. 비워두면 상단의 결제 키를 자동으로 사용합니다.
                            </p>
                            <div class="grid grid-cols-2 gap-4">
                                <div>
                                    <label class="block text-[10px] font-bold text-gray-400 uppercase mb-1">Auth Client Key</label>
                                     <div class="relative">
                                        <input type="text" id="auth-client-key" class="w-full text-xs border-gray-300 rounded-lg bg-gray-50 text-gray-600 pl-8 focus:ring-indigo-500 transition-colors" placeholder="Optional">
                                        <span class="material-symbols-outlined absolute left-2 top-1.5 text-gray-400 text-sm">key</span>
                                    </div>
                                </div>
                                <div>
                                    <label class="block text-[10px] font-bold text-gray-400 uppercase mb-1">Auth Secret Key</label>
                                    <div class="relative">
                                        <input type="text" id="auth-secret-key" class="w-full text-xs border-gray-300 rounded-lg bg-gray-100 text-gray-400 pl-8 cursor-not-allowed" value="🔒 환경변수로 관리됨" readonly disabled>
                                        <span class="material-symbols-outlined absolute left-2 top-1.5 text-green-500 text-sm">verified_user</span>
                                    </div>
                                    <p class="text-[10px] text-green-600 mt-1">firebase functions:config:set toss.auth_secret_key="..."</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- B. Global Economy Settings -->
                <div class="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                     <h4 class="font-bold text-gray-800 flex items-center gap-2 mb-4">
                        <span class="material-symbols-outlined text-gray-500">account_balance</span>
                        전역 경제 정책 (Global Economy)
                    </h4>

                    <div class="space-y-4">
                        <!-- Default Free Limit -->
                        <div class="p-4 bg-yellow-50 rounded-xl border border-yellow-100">
                            <label class="block text-sm font-bold text-yellow-800 mb-2 flex items-center gap-1">
                                <span class="material-symbols-outlined text-sm">confirmation_number</span>
                                전역 무료 회차 (Default Free Limit)
                            </label>
                            <div class="flex gap-2">
                                <input type="number" id="global-free-limit" class="flex-1 rounded-lg border-yellow-200 focus:ring-yellow-500 focus:border-yellow-500 text-sm" placeholder="Ex: 3">
                                <button id="save-limit-btn" class="px-4 py-2 bg-yellow-500 text-white text-sm rounded-lg hover:bg-yellow-600 font-bold shadow-sm">저장</button>
                            </div>
                             <p class="text-xs text-yellow-700 mt-2">
                                * 개별 작품 설정이 없을 때 적용되는 기본값입니다.<br>
                                * 현재 <strong>3화</strong>로 설정되어 있습니다.
                            </p>
                        </div>
                    </div>
                </div>

            </div>

            <!-- C. Pricing Policy (3-Tier) -->
            <div class="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                 <div class="flex justify-between items-center mb-6">
                    <h4 class="font-bold text-gray-800 flex items-center gap-2">
                        <span class="material-symbols-outlined text-gray-500">price_change</span>
                        콘텐츠 가격 정책 (3-Tier Pricing)
                    </h4>
                    <button id="save-pricing-btn" class="text-sm bg-indigo-50 text-indigo-700 px-3 py-1.5 rounded-lg font-bold hover:bg-indigo-100 transition-colors">변경사항 저장</button>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-3 gap-6 divide-y md:divide-y-0 md:divide-x divide-gray-100">
                    
                    <!-- Novel -->
                    <div class="p-2 space-y-4">
                         <h5 class="font-bold text-gray-800 flex items-center gap-2 pb-2 border-b border-gray-100">
                            <span class="material-symbols-outlined text-blue-500">text_snippet</span> 웹소설
                        </h5>
                        <div class="grid grid-cols-2 gap-4">
                             <div class="col-span-2">
                                <label class="text-xs font-bold text-gray-400 uppercase">Rent Price</label>
                                <div class="flex items-center gap-1 mt-1">
                                    <input type="number" data-key="webnovel.rent_price" class="pricing-input w-full border-gray-300 rounded text-sm bg-gray-50 focus:bg-white text-right">
                                    <span class="text-xs text-gray-500 font-bold">S</span>
                                </div>
                            </div>
                            <div class="col-span-2">
                                <label class="text-xs font-bold text-gray-400 uppercase">Own Price</label>
                                <div class="flex items-center gap-1 mt-1">
                                    <input type="number" data-key="webnovel.own_price" class="pricing-input w-full border-gray-300 rounded text-sm bg-gray-50 focus:bg-white text-right">
                                    <span class="text-xs text-gray-500 font-bold">S</span>
                                </div>
                            </div>
                             <div class="col-span-2">
                                <label class="text-xs font-bold text-gray-400 uppercase">Rent Days</label>
                                <div class="flex items-center gap-1 mt-1">
                                    <input type="number" data-key="webnovel.rent_days" class="pricing-input w-full border-gray-300 rounded text-sm bg-gray-50 focus:bg-white text-right">
                                    <span class="text-xs text-gray-500 font-bold">D</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Webtoon -->
                    <div class="p-2 space-y-4 md:pl-6">
                        <h5 class="font-bold text-gray-800 flex items-center gap-2 pb-2 border-b border-gray-100">
                            <span class="material-symbols-outlined text-green-500">collections</span> 웹툰
                        </h5>
                         <div class="grid grid-cols-2 gap-4">
                             <div class="col-span-2">
                                <label class="text-xs font-bold text-gray-400 uppercase">Rent Price</label>
                                <div class="flex items-center gap-1 mt-1">
                                    <input type="number" data-key="webtoon.rent_price" class="pricing-input w-full border-gray-300 rounded text-sm bg-gray-50 focus:bg-white text-right">
                                    <span class="text-xs text-gray-500 font-bold">S</span>
                                </div>
                            </div>
                            <div class="col-span-2">
                                <label class="text-xs font-bold text-gray-400 uppercase">Own Price</label>
                                <div class="flex items-center gap-1 mt-1">
                                    <input type="number" data-key="webtoon.own_price" class="pricing-input w-full border-gray-300 rounded text-sm bg-gray-50 focus:bg-white text-right">
                                    <span class="text-xs text-gray-500 font-bold">S</span>
                                </div>
                            </div>
                             <div class="col-span-2">
                                <label class="text-xs font-bold text-gray-400 uppercase">Rent Days</label>
                                <div class="flex items-center gap-1 mt-1">
                                    <input type="number" data-key="webtoon.rent_days" class="pricing-input w-full border-gray-300 rounded text-sm bg-gray-50 focus:bg-white text-right">
                                    <span class="text-xs text-gray-500 font-bold">D</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Cine-Novel -->
                    <div class="p-2 space-y-4 md:pl-6">
                         <h5 class="font-bold text-gray-800 flex items-center gap-2 pb-2 border-b border-gray-100">
                            <span class="material-symbols-outlined text-purple-500">movie</span> 시네노블
                        </h5>
                         <div class="grid grid-cols-2 gap-4">
                             <div class="col-span-2">
                                <label class="text-xs font-bold text-gray-400 uppercase">Rent Price</label>
                                <div class="flex items-center gap-1 mt-1">
                                    <input type="number" data-key="davinci.rent_price" class="pricing-input w-full border-gray-300 rounded text-sm bg-gray-50 focus:bg-white text-right">
                                    <span class="text-xs text-gray-500 font-bold">S</span>
                                </div>
                            </div>
                            <div class="col-span-2">
                                <label class="text-xs font-bold text-gray-400 uppercase">Own Price</label>
                                <div class="flex items-center gap-1 mt-1">
                                    <input type="number" data-key="davinci.own_price" class="pricing-input w-full border-gray-300 rounded text-sm bg-gray-50 focus:bg-white text-right">
                                    <span class="text-xs text-gray-500 font-bold">S</span>
                                </div>
                            </div>
                             <div class="col-span-2">
                                <label class="text-xs font-bold text-gray-400 uppercase">Rent Days</label>
                                <div class="flex items-center gap-1 mt-1">
                                    <input type="number" data-key="davinci.rent_days" class="pricing-input w-full border-gray-300 rounded text-sm bg-gray-50 focus:bg-white text-right">
                                    <span class="text-xs text-gray-500 font-bold">D</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <!-- E. Subscription Policy -->
            <div class="bg-white p-6 rounded-xl border border-gray-200 shadow-sm border-t-4 border-t-purple-500 mb-6">
                 <div class="flex justify-between items-center mb-6">
                    <h4 class="font-bold text-gray-800 flex items-center gap-2 text-lg">
                        <span class="material-symbols-outlined text-purple-500">loyalty</span>
                        멤버십 구독 설정 (Subscription Policy)
                    </h4>
                    <button id="save-sub-btn" class="bg-purple-600 text-white px-3 py-1.5 rounded-lg text-sm font-bold hover:bg-purple-700 shadow-sm transition-colors">설정 저장</button>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                     <div class="p-4 bg-purple-50 rounded-xl border border-purple-100 flex items-center justify-between">
                        <div>
                            <p class="font-bold text-purple-900 text-sm">구독 기능 활성화 (Feature Toggle)</p>
                            <p class="text-xs text-purple-600 mt-1">활성화 시 마이페이지의 'Upgrade' 버튼이 작동합니다.</p>
                        </div>
                        <label class="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" id="sub-active-switch" class="sr-only peer">
                            <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600 transition-colors"></div>
                        </label>
                    </div>

                    <div class="p-4 bg-white rounded-xl border border-gray-200">
                        <label class="block text-xs font-bold text-gray-500 uppercase mb-1">월 구독료 (KRW)</label>
                        <div class="flex items-center gap-2">
                             <input type="number" id="sub-price-input" class="w-full border-gray-300 rounded-lg text-sm font-bold text-right" placeholder="9900">
                             <span class="text-sm font-bold text-gray-500">원/월</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- E. Activity Rewards Dynamic Config -->
            <div class="bg-white p-6 rounded-xl border border-gray-200 shadow-sm border-t-4 border-t-emerald-400">
                <div class="flex justify-between items-center mb-5">
                    <div>
                        <h4 class="font-bold text-gray-800 flex items-center gap-2 text-lg">
                            <span class="material-symbols-outlined text-emerald-500">emoji_events</span>
                            액티비티 포인트 설정
                        </h4>
                        <p class="text-xs text-gray-500 mt-1">모든 보상 포인트를 실시간으로 조정합니다. 저장 즉시 서버에 반영됩니다.</p>
                    </div>
                    <button id="save-rewards-btn" class="px-4 py-2 bg-emerald-600 text-white text-sm font-bold rounded-lg hover:bg-emerald-700 flex items-center gap-1 shadow-md transition-all active:scale-95">
                        <span class="material-symbols-outlined text-sm">save</span> 저장
                    </button>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
                    <!-- Attendance -->
                    <div class="bg-gray-50 rounded-lg p-4 border border-gray-100">
                        <div class="flex justify-between items-center mb-2">
                            <label class="text-xs font-bold text-gray-600 uppercase flex items-center gap-1">
                                <span class="material-symbols-outlined text-sm text-blue-500">calendar_month</span> 출석 보상
                            </label>
                            <input type="checkbox" id="rw-attendance-enabled" class="rounded" checked>
                        </div>
                        <div class="flex items-center gap-2">
                            <input type="number" id="rw-attendance-amount" class="w-full border-gray-300 rounded-lg text-sm font-bold text-right" value="10">
                            <span class="text-sm font-bold text-gray-500 whitespace-nowrap">P/일</span>
                        </div>
                    </div>

                    <!-- Reading -->
                    <div class="bg-gray-50 rounded-lg p-4 border border-gray-100">
                        <div class="flex justify-between items-center mb-2">
                            <label class="text-xs font-bold text-gray-600 uppercase flex items-center gap-1">
                                <span class="material-symbols-outlined text-sm text-green-500">auto_stories</span> 감상 보상
                            </label>
                            <input type="checkbox" id="rw-reading-enabled" class="rounded" checked>
                        </div>
                        <div class="flex items-center gap-2 mb-2">
                            <input type="number" id="rw-reading-amount" class="w-full border-gray-300 rounded-lg text-sm font-bold text-right" value="1">
                            <span class="text-sm font-bold text-gray-500 whitespace-nowrap">P/편</span>
                        </div>
                        <div class="flex items-center gap-3 text-[11px] text-gray-500">
                            <label class="flex items-center gap-1"><input type="checkbox" id="rw-reading-dedup" class="rounded" checked> 중복 방지</label>
                            <label class="flex items-center gap-1">일일 상한 <input type="number" id="rw-reading-cap" class="w-14 border-gray-300 rounded text-xs text-right" value="10"> P</label>
                        </div>
                    </div>

                    <!-- Welcome -->
                    <div class="bg-gray-50 rounded-lg p-4 border border-gray-100">
                        <div class="flex justify-between items-center mb-2">
                            <label class="text-xs font-bold text-gray-600 uppercase flex items-center gap-1">
                                <span class="material-symbols-outlined text-sm text-purple-500">waving_hand</span> 가입 환영
                            </label>
                            <input type="checkbox" id="rw-welcome-enabled" class="rounded" checked>
                        </div>
                        <div class="flex items-center gap-2">
                            <input type="number" id="rw-welcome-amount" class="w-full border-gray-300 rounded-lg text-sm font-bold text-right" value="100">
                            <span class="text-sm font-bold text-gray-500 whitespace-nowrap">P</span>
                        </div>
                    </div>

                    <!-- Referral -->
                    <div class="bg-gray-50 rounded-lg p-4 border border-gray-100">
                        <div class="flex justify-between items-center mb-2">
                            <label class="text-xs font-bold text-gray-600 uppercase flex items-center gap-1">
                                <span class="material-symbols-outlined text-sm text-orange-500">group_add</span> 친구 초대
                            </label>
                            <input type="checkbox" id="rw-referral-enabled" class="rounded" checked>
                        </div>
                        <div class="flex items-center gap-2">
                            <input type="number" id="rw-referral-amount" class="w-full border-gray-300 rounded-lg text-sm font-bold text-right" value="500">
                            <span class="text-sm font-bold text-gray-500 whitespace-nowrap">P (쌍방)</span>
                        </div>
                    </div>

                    <!-- Share -->
                    <div class="bg-gray-50 rounded-lg p-4 border border-gray-100">
                        <div class="flex justify-between items-center mb-2">
                            <label class="text-xs font-bold text-gray-600 uppercase flex items-center gap-1">
                                <span class="material-symbols-outlined text-sm text-pink-500">share</span> 공유 보상
                            </label>
                            <input type="checkbox" id="rw-share-enabled" class="rounded" checked>
                        </div>
                        <div class="flex items-center gap-2">
                            <input type="number" id="rw-share-amount" class="w-full border-gray-300 rounded-lg text-sm font-bold text-right" value="5">
                            <span class="text-sm font-bold text-gray-500 whitespace-nowrap">P</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- D. Star Products Management (Enhanced) -->
            <div class="bg-white p-6 rounded-xl border border-gray-200 shadow-sm border-t-4 border-t-yellow-400">
                 <div class="flex justify-between items-center mb-6">
                    <div>
                        <h4 class="font-bold text-gray-800 flex items-center gap-2 text-lg">
                            <span class="material-symbols-outlined text-yellow-500">stars</span>
                            스타 상품 관리 (Dynamic Product Engine)
                        </h4>
                        <p class="text-xs text-gray-500 mt-1">충전소에 노출될 상품 리스트입니다. 수정 즉시 반영됩니다.</p>
                    </div>
                    <div class="flex gap-2">
                        <button id="reset-products-btn" class="px-3 py-1.5 bg-gray-100 text-gray-600 text-sm rounded hover:bg-gray-200 flex items-center gap-1 border border-gray-200">
                            <span class="material-symbols-outlined text-sm">restart_alt</span> 기본값 복구
                        </button>
                        <button id="add-product-btn" class="px-3 py-1.5 bg-indigo-600 text-white text-sm rounded hover:bg-indigo-700 flex items-center gap-1 shadow-md">
                            <span class="material-symbols-outlined text-sm">add</span> 상품 추가
                        </button>
                    </div>
                </div>

                <div class="overflow-x-auto rounded-lg border border-gray-200">
                    <table class="w-full text-sm text-left text-gray-500">
                        <thead class="text-xs text-gray-700 uppercase bg-gray-50 border-b border-gray-200">
                            <tr>
                                <th class="px-4 py-3">Order</th>
                                <th class="px-4 py-3">상품 정보 (Name / Sub)</th>
                                <th class="px-4 py-3">가격 (KRW)</th>
                                <th class="px-4 py-3">지급 스타</th>
                                <th class="px-4 py-3">보너스 (%)</th>
                                <th class="px-4 py-3 text-center">속성 (Badge / Color)</th>
                                <th class="px-4 py-3 text-right">관리</th>
                            </tr>
                        </thead>
                        <tbody id="product-list-body" class="divide-y divide-gray-100 bg-white">
                            <tr><td colspan="7" class="px-4 py-10 text-center text-gray-400"><span class="loader-spin inline-block w-6 h-6 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin"></span> Loading Products...</td></tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    `;

    // 2. Logic & Event Bindings
    const pgModeSwitch = container.querySelector('#pg-mode-switch');
    const labelTest = container.querySelector('#label-test');
    const labelLive = container.querySelector('#label-live');

    // State
    let globalPricing = {};
    let globalEnv = {};

    // Default Products Definition
    const DEFAULT_PRODUCTS = [
        { "id": "stardust", "order_index": 1, "name": "Stardust", "sub_name": "스타 더스트", "price": 1000, "amount": 1000, "bonus_rate": 0, "theme_color": "gray", "badge_text": "", "is_active": true },
        { "id": "shooting_star", "order_index": 2, "name": "Shooting Star", "sub_name": "슈팅 스타", "price": 5000, "amount": 5100, "bonus_rate": 2, "theme_color": "blue", "badge_text": "", "is_active": true },
        { "id": "little_bear", "order_index": 3, "name": "Little Bear", "sub_name": "리틀 베어", "price": 10000, "amount": 10500, "bonus_rate": 5, "theme_color": "purple", "badge_text": "", "is_active": true },
        { "id": "silver_river", "order_index": 4, "name": "Silver River", "sub_name": "실버 리버", "price": 30000, "amount": 32400, "bonus_rate": 8, "theme_color": "silver", "badge_text": "", "is_active": true },
        { "id": "galaxy_master", "order_index": 5, "name": "Galaxy Master", "sub_name": "갤럭시 마스터", "price": 50000, "amount": 56000, "bonus_rate": 12, "theme_color": "gold", "badge_text": "", "is_active": true },
        { "id": "star_maker", "order_index": 6, "name": "Star Maker", "sub_name": "스타 메이커 (VVIP)", "price": 100000, "amount": 115000, "bonus_rate": 15, "theme_color": "red", "badge_text": "BEST", "is_active": true }
    ];

    // 2.1 Load Data
    let loadAll = async () => {
        try {
            // A. Global Settings
            const settings = await AdminEconomyService.getGlobalEconomy() || {};
            globalEnv = settings;

            // Render Free Limit
            container.querySelector('#global-free-limit').value = settings.default_free_limit || 3;

            // Render Pricing Inputs
            if (settings.prices) {
                globalPricing = settings.prices;
                container.querySelectorAll('.pricing-input').forEach(input => {
                    const keyPath = input.dataset.key.split('.');
                    if (globalPricing[keyPath[0]] && globalPricing[keyPath[0]][keyPath[1]]) {
                        input.value = globalPricing[keyPath[0]][keyPath[1]];
                    }
                });
            }

            // Render PG Mode
            const isLive = settings.pg_mode === 'LIVE';
            pgModeSwitch.checked = isLive;

            // Set Initial Keys
            const clientKeyInput = container.querySelector('#pg-client-key');
            const secretKeyInput = container.querySelector('#pg-secret-key');
            const authClientKeyInput = container.querySelector('#auth-client-key');
            const authSecretKeyInput = container.querySelector('#auth-secret-key');

            if (isLive) {
                // Load Saved Keys (Masked Secret)
                clientKeyInput.value = settings.pg_client_key || '';
                secretKeyInput.value = settings.pg_secret_key || '';
                // [NEW] Load Auth Keys
                authClientKeyInput.value = settings.auth_client_key || '';
                authSecretKeyInput.value = settings.auth_secret_key || '';
            } else {
                // Force Test Keys
                clientKeyInput.value = "test_ck_ORzdMaqN3wP69dp6QpagV5AkYXQG";
                secretKeyInput.value = "🔒 환경변수로 관리됨 (CLI 전용)";
                // Auth Test Keys (Placeholder - empty implies fallback or unused)
                authClientKeyInput.value = "";
                authSecretKeyInput.value = "";
            }

            updatePgModeUI(isLive);

            // [New] Subscription Settings
            const subActiveSwitch = container.querySelector('#sub-active-switch');
            const subPriceInput = container.querySelector('#sub-price-input');
            if (subActiveSwitch) subActiveSwitch.checked = !!settings.subscription_active;
            if (subPriceInput) subPriceInput.value = settings.subscription_price || 9900;

            // B. Products
            let products = await AdminEconomyService.getProducts();

            // Auto-Seed Defaults if Empty
            if (products.length === 0) {
                console.log("No products found. Auto-seeding defaults...");
                for (const p of DEFAULT_PRODUCTS) {
                    await AdminEconomyService.saveProduct(p);
                }
                products = await AdminEconomyService.getProducts(); // Re-fetch
            }

            renderProducts(products);

            // D. Activity Rewards Config
            const rewardsConfig = await AdminEconomyService.getActivityRewards();
            const setVal = (id, val) => { const el = container.querySelector('#' + id); if (el) el.value = val; };
            const setChk = (id, val) => { const el = container.querySelector('#' + id); if (el) el.checked = !!val; };
            setVal('rw-attendance-amount', rewardsConfig.attendance?.amount ?? 10);
            setChk('rw-attendance-enabled', rewardsConfig.attendance?.enabled ?? true);
            setVal('rw-reading-amount', rewardsConfig.reading?.amount ?? 1);
            setChk('rw-reading-enabled', rewardsConfig.reading?.enabled ?? true);
            setChk('rw-reading-dedup', rewardsConfig.reading?.dedup ?? true);
            setVal('rw-reading-cap', rewardsConfig.reading?.dailyCap ?? 10);
            setVal('rw-welcome-amount', rewardsConfig.welcome?.amount ?? 100);
            setChk('rw-welcome-enabled', rewardsConfig.welcome?.enabled ?? true);
            setVal('rw-referral-amount', rewardsConfig.referral?.amount ?? 500);
            setChk('rw-referral-enabled', rewardsConfig.referral?.enabled ?? true);
            setVal('rw-share-amount', rewardsConfig.share?.amount ?? 5);
            setChk('rw-share-enabled', rewardsConfig.share?.enabled ?? true);

            // E. Stats (Real Data)
            const stats = await AdminEconomyService.getDailyFlow();
            document.getElementById('stat-revenue-krw').textContent = (stats.revenue || 0).toLocaleString();
            document.getElementById('stat-minted-stars').textContent = stats.minted.toLocaleString();
            document.getElementById('stat-bonus-rate').textContent = (stats.avgBonus || 0) + '%';

        } catch (e) {
            console.error(e);
            await window.Modal.alert("데이터 로딩 실패: " + e.message);
        }
    };

    // 2.1.1 Save Activity Rewards
    const saveRewardsBtn = container.querySelector('#save-rewards-btn');
    if (saveRewardsBtn) {
        saveRewardsBtn.onclick = async () => {
            try {
                const gv = (id) => Number(container.querySelector('#' + id)?.value) || 0;
                const gc = (id) => !!container.querySelector('#' + id)?.checked;

                await AdminEconomyService.updateActivityRewards({
                    attendance: { amount: gv('rw-attendance-amount'), enabled: gc('rw-attendance-enabled') },
                    reading: { amount: gv('rw-reading-amount'), enabled: gc('rw-reading-enabled'), dedup: gc('rw-reading-dedup'), dailyCap: gv('rw-reading-cap') },
                    welcome: { amount: gv('rw-welcome-amount'), enabled: gc('rw-welcome-enabled') },
                    referral: { amount: gv('rw-referral-amount'), enabled: gc('rw-referral-enabled') },
                    share: { amount: gv('rw-share-amount'), enabled: gc('rw-share-enabled') }
                });
                window.Modal.toast('✅ 액티비티 포인트 설정이 저장되었습니다.');
            } catch (e) {
                console.error(e);
                window.Modal.alert('저장 실패: ' + e.message);
            }
        };
    }

    // 2.2 Helper UIs
    const updatePgModeUI = (isLive) => {
        // Toggle Styles
        if (isLive) {
            labelTest.className = "text-xs font-bold text-gray-300 transition-colors";
            labelLive.className = "text-xs font-bold text-red-600 transition-colors";
            pgModeSwitch.parentElement.querySelector('div').classList.replace('bg-gray-200', 'bg-red-500'); // Ensure Checked bg
        } else {
            labelTest.className = "text-xs font-bold text-green-600 transition-colors";
            labelLive.className = "text-xs font-bold text-gray-300 transition-colors";
            pgModeSwitch.parentElement.querySelector('div').classList.replace('bg-red-500', 'bg-gray-200');
        }

        // Input State
        const clientKeyInput = container.querySelector('#pg-client-key');
        const secretKeyInput = container.querySelector('#pg-secret-key');
        const authClientKeyInput = container.querySelector('#auth-client-key');
        const authSecretKeyInput = container.querySelector('#auth-secret-key');

        const inputs = [clientKeyInput, secretKeyInput, authClientKeyInput, authSecretKeyInput];

        if (isLive) {
            inputs.forEach(input => {
                input.readOnly = false;
                input.className = "w-full text-xs border-indigo-500 ring-2 ring-indigo-200 rounded-lg bg-white text-gray-900 pl-8 focus:ring-4 focus:ring-indigo-500 shadow-sm transition-all font-bold";
            });

            clientKeyInput.placeholder = "실제 발급받은 LIVE Client Key를 입력하세요 (저장 필수)";
            secretKeyInput.placeholder = "실제 발급받은 LIVE Secret Key를 입력하세요 (저장 필수)";

            // Auth Inputs hint
            authClientKeyInput.placeholder = "본인인증 Client Key (Optional)";
            authSecretKeyInput.placeholder = "본인인증 Secret Key (Optional)";

            // Show Save Hint
            const saveBtn = container.querySelector('#save-pg-btn');
            saveBtn.classList.add('ring-4', 'ring-red-300', 'animate-pulse');
            setTimeout(() => saveBtn.classList.remove('ring-4', 'ring-red-300', 'animate-pulse'), 3000);
        } else {
            inputs.forEach(input => {
                input.readOnly = true;
                input.className = "w-full text-xs border-gray-300 rounded-lg bg-gray-50 text-gray-500 cursor-not-allowed pl-8";
            });

            clientKeyInput.value = "test_ck_D5GePWvyJnrK0W0k6q8gLzN97Eoq";
            secretKeyInput.value = "\ud83d\udd12 \ud658\uacbd\ubcc0\uc218\ub85c \uad00\ub9ac\ub428 (CLI \uc804\uc6a9)";

            // Auth keys in test mode
            authClientKeyInput.value = "";
            authSecretKeyInput.value = "";
        }
    };

    // PG Mode Switch Logic
    pgModeSwitch.addEventListener('click', async (e) => {
        e.preventDefault(); // Control purely via logic

        const currentIsLive = pgModeSwitch.checked;

        // Check against current UI state, not just clicked state
        const isCurrentlyLive = globalEnv.pg_mode === 'LIVE';
        const willBeLive = !isCurrentlyLive;

        if (willBeLive) {
            // Test -> Live
            if (await window.Modal.confirm(
                "정말 결제 시스템을 [LIVE] 모드로 전환하시겠습니까?\n\n⚠️ 실제 결제가 발생하며, 매출처리가 시작됩니다.\n반드시 실제 발급받은 키를 입력해야 합니다.",
                "LIVE 전환 경고",
                "전환", "취소"
            )) {
                // User Confirmed
                globalEnv.pg_mode = 'LIVE';
                pgModeSwitch.checked = true;

                // Clear inputs for manual entry (or keep saved)
                const clientKeyInput = container.querySelector('#pg-client-key');
                const secretKeyInput = container.querySelector('#pg-secret-key');
                const authClientKeyInput = container.querySelector('#auth-client-key');
                const authSecretKeyInput = container.querySelector('#auth-secret-key');

                if (globalEnv.pg_client_key) clientKeyInput.value = globalEnv.pg_client_key;
                else clientKeyInput.value = ""; // Clear test key

                if (globalEnv.pg_secret_key) secretKeyInput.value = globalEnv.pg_secret_key;
                else secretKeyInput.value = "";

                // Load Auth keys if exist
                authClientKeyInput.value = globalEnv.auth_client_key || "";
                authSecretKeyInput.value = globalEnv.auth_secret_key || "";

                updatePgModeUI(true);

                // Explicitly warn about Saving
                window.Modal.toast("⚠️ 주의: 키 입력 후 우측 상단 [설정 저장]을 반드시 눌러야 적용됩니다!");
            }
        } else {
            // Live -> Test
            if (await window.Modal.confirm(
                "테스트 모드로 돌아가시겠습니까?\n\n모든 결제가 시물레이션으로 전환됩니다.",
                "TEST 모드 복귀"
            )) {
                globalEnv.pg_mode = 'TEST';
                pgModeSwitch.checked = false;
                updatePgModeUI(false); // Will restore test keys
            }
        }
    });

    // Save Subscription Settings
    const subSaveBtn = container.querySelector('#save-sub-btn');
    if (subSaveBtn) {
        subSaveBtn.onclick = async () => {
            try {
                const isActive = container.querySelector('#sub-active-switch').checked;
                const price = parseInt(container.querySelector('#sub-price-input').value) || 9900;

                await AdminEconomyService.updateGlobalEconomy({
                    subscription_active: isActive,
                    subscription_price: price
                });

                window.Modal.toast("구독 설정이 저장되었습니다.");
                // Update local env cache if needed
                globalEnv.subscription_active = isActive;
                globalEnv.subscription_price = price;

            } catch (e) {
                window.Modal.alert("저장 실패: " + e.message);
            }
        };
    }

    // Save PG Settings
    container.querySelector('#save-pg-btn').onclick = async () => {
        const isLive = pgModeSwitch.checked;
        const ck = container.querySelector('#pg-client-key').value.trim();
        const authCk = container.querySelector('#auth-client-key').value.trim();

        if (isLive && !ck) {
            return window.Modal.alert("LIVE 모드에서는 결제용 Client Key를 반드시 입력해야 합니다.\n\nSecret Key는 서버 환경변수로 관리됩니다:\nfirebase functions:config:set toss.live_secret_key=\"live_sk_...\"");
        }

        try {
            // [SECURITY] Secret Keys are NO LONGER stored in Firestore
            // They are managed exclusively via Firebase Functions environment config
            await AdminEconomyService.updateGlobalEconomy({
                pg_mode: isLive ? 'LIVE' : 'TEST',
                pg_client_key: ck,
                auth_client_key: authCk, // Optional (public key, safe to store)
                // pg_secret_key: REMOVED — managed via CLI env vars
                // auth_secret_key: REMOVED — managed via CLI env vars
            });
            await window.Modal.toast("결제 설정이 저장되었습니다. (Secret Key는 환경변수로 관리됩니다)");
            globalEnv.pg_mode = isLive ? 'LIVE' : 'TEST';
            globalEnv.pg_client_key = ck;
            globalEnv.auth_client_key = authCk;
        } catch (e) {
            window.Modal.alert("저장 실패: " + e.message);
        }
    };

    // [FIX v1.36.192] Missing Listeners Implementation

    // 1. Save Global Free Limit
    container.querySelector('#save-limit-btn').onclick = async () => {
        try {
            const limitInput = container.querySelector('#global-free-limit');
            const limitVal = parseInt(limitInput.value);

            if (isNaN(limitVal) || limitVal < 0) {
                return window.Modal.alert("유효한 숫자를 입력해주세요.");
            }

            await AdminEconomyService.updateGlobalEconomy({
                default_free_limit: limitVal
            });
            await window.Modal.toast("전역 무료 회차 설정이 저장되었습니다.");

            // Update Local Cache
            globalEnv.default_free_limit = limitVal;

        } catch (e) {
            window.Modal.alert("저장 실패: " + e.message);
        }
    };

    // 2. Save Pricing Policy
    container.querySelector('#save-pricing-btn').onclick = async () => {
        try {
            // Construct Prices Object
            const newPrices = {};
            container.querySelectorAll('.pricing-input').forEach(input => {
                const parts = input.dataset.key.split('.'); // e.g. webnovel.rent_price
                const type = parts[0];
                const key = parts[1];
                const val = parseInt(input.value);

                if (!newPrices[type]) newPrices[type] = {};
                newPrices[type][key] = isNaN(val) ? 0 : val;
            });

            await AdminEconomyService.updateGlobalEconomy({
                prices: newPrices
            });
            await window.Modal.toast("콘텐츠 가격 정책이 저장되었습니다.");

            // Update Local Cache
            globalEnv.prices = newPrices;

        } catch (e) {
            window.Modal.alert("저장 실패: " + e.message);
        }
    };

    const renderProducts = (products) => {
        const tbody = document.getElementById('product-list-body');
        if (products.length === 0) {
            tbody.innerHTML = `<tr><td colspan="8" class="px-4 py-8 text-center text-gray-500 italic">등록된 상품이 없습니다. '기본값 복구'를 눌러 초기화하세요.</td></tr>`;
            return;
        }

        // Sort by order_index
        products.sort((a, b) => (a.order_index || 0) - (b.order_index || 0));

        tbody.innerHTML = products.map(p => `
            <tr class="hover:bg-gray-50 group transition-colors grid-row" draggable="true" data-id="${p.id}">
                <!-- 1. Drag -->
                <td class="px-2 py-3 text-center text-gray-400 w-10">
                    <span class="material-symbols-outlined text-sm cursor-grab active:cursor-grabbing handle">drag_indicator</span>
                </td>

                <!-- 2. Basic Info (Inline Edit) -->
                <td class="px-2 py-3">
                    <input type="text" class="w-full text-sm font-bold border-gray-200 rounded focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 mb-1 edit-field" data-field="name" value="${p.name}" placeholder="상품명">
                    <input type="text" class="w-full text-xs text-gray-500 border-gray-100 rounded focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 edit-field" data-field="sub_name" value="${p.sub_name || ''}" placeholder="서브 설명">
                </td>

                <!-- 3. Price (Inline) -->
                <td class="px-2 py-3 w-32">
                    <div class="flex items-center">
                        <span class="text-xs text-gray-400 mr-1">₩</span>
                        <input type="number" class="w-full text-sm font-bold text-right border-gray-200 rounded focus:border-indigo-500 edit-field" data-field="price" value="${p.price}">
                    </div>
                </td>

                <!-- 4. Amount (Inline) -->
                <td class="px-2 py-3 w-32">
                    <div class="flex items-center">
                        <input type="number" class="w-full text-sm font-bold text-indigo-600 text-right border-gray-200 rounded focus:border-indigo-500 edit-field" data-field="amount" value="${p.amount}">
                        <span class="text-xs text-gray-400 ml-1">S</span>
                    </div>
                </td>

                <!-- 5. Bonus (Inline) -->
                <td class="px-2 py-3 w-24">
                     <div class="flex items-center">
                        <input type="number" class="w-full text-sm font-bold text-green-600 text-right border-gray-200 rounded focus:border-indigo-500 edit-field" data-field="bonus_rate" value="${p.bonus_rate || 0}">
                        <span class="text-xs text-gray-400 ml-1">%</span>
                    </div>
                </td>

                <!-- 6. Event/Design (Popup Trigger) -->
                <td class="px-4 py-3 text-center">
                    <button class="event-settings-btn flex flex-col items-center justify-center gap-1 w-full p-1 rounded hover:bg-gray-100 transition-colors" data-id="${p.id}" data-json='${JSON.stringify(p)}'>
                        <div class="flex items-center gap-1">
                            ${p.badge_text ? `<span class="px-1.5 py-0.5 bg-red-100 text-red-600 text-[9px] rounded-sm font-bold border border-red-200">${p.badge_text}</span>` : '<span class="text-[9px] text-gray-300">No Badge</span>'}
                            <span class="w-2.5 h-2.5 rounded-full border border-gray-300" style="background-color: ${p.theme_color || 'gray'}"></span>
                        </div>
                         ${p.promotion_end ? `<span class="text-[9px] text-yellow-600 font-bold bg-yellow-50 px-1 rounded">~ ${new Date(p.promotion_end).toLocaleDateString()}</span>` : '<span class="text-[9px] text-gray-300">상시 판매</span>'}
                    </button>
                    ${p.promotion_end ? '<div class="h-1 w-full bg-yellow-400 rounded-full mt-1 animate-pulse"></div>' : ''}
                </td>

                <!-- 7. Actions -->
                <td class="px-2 py-3 text-right">
                    <div class="flex items-center justify-end gap-1">
                        <button class="save-row-btn text-gray-300 hover:text-indigo-600 p-1.5 rounded-full hover:bg-indigo-50 transition-colors" title="저장" data-id="${p.id}">
                            <span class="material-symbols-outlined text-lg">save</span>
                        </button>
                        <button class="delete-product-btn text-gray-300 hover:text-red-600 p-1.5 rounded-full hover:bg-red-50 transition-colors" title="삭제" data-id="${p.id}">
                            <span class="material-symbols-outlined text-lg">delete</span>
                        </button>
                    </div>
                </td>
            </tr>
        `).join('');

        // Re-bind Events
        bindTableEvents(tbody);
    };

    const bindTableEvents = (tbody) => {
        // 1. Drag & Drop (HTML5)
        let dragSrcEl = null;
        tbody.querySelectorAll('tr[draggable="true"]').forEach(row => {
            row.addEventListener('dragstart', (e) => {
                dragSrcEl = row;
                e.dataTransfer.effectAllowed = 'move';
                e.dataTransfer.setData('text/html', row.innerHTML);
                row.classList.add('opacity-50', 'bg-indigo-50');
            });

            row.addEventListener('dragover', (e) => {
                if (e.preventDefault) e.preventDefault();
                e.dataTransfer.dropEffect = 'move';
                return false;
            });

            row.addEventListener('drop', async (e) => {
                if (e.stopPropagation) e.stopPropagation();
                if (dragSrcEl !== row) {
                    const allRows = [...tbody.querySelectorAll('tr')];
                    const srcIndex = allRows.indexOf(dragSrcEl);
                    const targetIndex = allRows.indexOf(row);

                    if (srcIndex < targetIndex) {
                        row.after(dragSrcEl);
                    } else {
                        row.before(dragSrcEl);
                    }

                    // Auto-Save Order
                    const newOrder = [...tbody.querySelectorAll('tr')].map((r, idx) => ({
                        id: r.dataset.id,
                        order_index: idx + 1
                    }));

                    for (const item of newOrder) {
                        await AdminEconomyService.saveProduct({ id: item.id, order_index: item.order_index }, true); // Partial update if supported, or just merge
                    }
                }
                return false;
            });

            row.addEventListener('dragend', () => {
                row.classList.remove('opacity-50', 'bg-indigo-50');
            });

            // 1.1 Auto-Calculation Logic
            const priceInput = row.querySelector('input[data-field="price"]');
            const bonusInput = row.querySelector('input[data-field="bonus_rate"]');
            const amountInput = row.querySelector('input[data-field="amount"]');

            const updateAmount = () => {
                const price = parseInt(priceInput.value) || 0;
                const bonus = parseInt(bonusInput.value) || 0;
                // Formula: Amount = Price + (Price * Bonus / 100)
                const total = price + Math.floor(price * bonus / 100);
                amountInput.value = total;
            };

            if (priceInput && bonusInput && amountInput) {
                priceInput.addEventListener('input', updateAmount);
                bonusInput.addEventListener('input', updateAmount);
            }
        });

        // 2. Row Actions

        // [Save Row]
        tbody.querySelectorAll('.save-row-btn').forEach(btn => {
            btn.onclick = async () => {
                try {
                    const row = btn.closest('tr');
                    const id = btn.dataset.id;

                    // Get hidden data from the Event Button (it allows us to carry over non-visible fields)
                    // Note: Stored JSON is from render time. We merge new inputs into it.
                    const eventBtn = row.querySelector('.event-settings-btn');
                    const baseData = JSON.parse(eventBtn.dataset.json);

                    // Gather Inputs
                    const name = row.querySelector('input[data-field="name"]').value;
                    const sub = row.querySelector('input[data-field="sub_name"]').value;
                    const price = parseInt(row.querySelector('input[data-field="price"]').value);
                    const amount = parseInt(row.querySelector('input[data-field="amount"]').value);
                    const rate = parseInt(row.querySelector('input[data-field="bonus_rate"]').value) || 0;

                    if (!name || isNaN(price) || isNaN(amount)) throw new Error("필수 정보를 입력해주세요.");

                    const payload = {
                        ...baseData, // Keep ID, order, dates, badge, color
                        name,
                        sub_name: sub,
                        price,
                        amount,
                        bonus_rate: rate
                    };

                    await AdminEconomyService.saveProduct(payload);
                    await window.Modal.toast("저장되었습니다.");

                    // Update the JSON blob for next time to prevent staleness without reload
                    eventBtn.dataset.json = JSON.stringify(payload);

                    // Visual Feedback
                    const originalColor = btn.style.color;
                    btn.style.color = '#4ade80'; // Green
                    setTimeout(() => btn.style.color = originalColor, 1000);

                } catch (e) {
                    window.Modal.alert(e.message);
                }
            };
        });

        // [Delete Row]
        tbody.querySelectorAll('.delete-product-btn').forEach(btn => {
            btn.onclick = async () => {
                if (await window.Modal.confirm("정말 이 상품을 삭제하시겠습니까? (즉시 반영)", "삭제 확인")) {
                    await AdminEconomyService.deleteProduct(btn.dataset.id);
                    loadAll();
                }
            };
        });

        // [Event Settings Popup]
        tbody.querySelectorAll('.event-settings-btn').forEach(btn => {
            btn.onclick = () => {
                // Pass current row values to popup to avoid overwriting with stale JSON
                const row = btn.closest('tr');
                const baseData = JSON.parse(btn.dataset.json);

                const currentData = {
                    ...baseData,
                    name: row.querySelector('input[data-field="name"]').value,
                    sub_name: row.querySelector('input[data-field="sub_name"]').value,
                    price: parseInt(row.querySelector('input[data-field="price"]').value),
                    amount: parseInt(row.querySelector('input[data-field="amount"]').value),
                    bonus_rate: parseInt(row.querySelector('input[data-field="bonus_rate"]').value) || 0
                };

                openProductEditor(currentData);
            };
        });
    };

    // Custom DOM Modal for Product Editor (Fixing [object Object] bug)
    const openProductEditor = (product = null) => {
        const isEdit = !!product;

        // Remove existing if any
        const existing = document.getElementById('product-editor-overlay');
        if (existing) existing.remove();

        const formatIsoDate = (ts) => {
            if (!ts) return '';
            // ts can be Firestore Timestamp or millis
            const d = ts.seconds ? new Date(ts.seconds * 1000) : new Date(ts);
            // Return YYYY-MM-DDTHH:mm
            return d.toISOString().slice(0, 16);
        };

        const overlay = document.createElement('div');
        overlay.id = 'product-editor-overlay';
        overlay.className = "fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in";
        overlay.innerHTML = `
            <div class="bg-white w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]">
                <!-- Header -->
                <div class="px-6 py-4 border-b border-gray-100 flex justify-between items-center bg-gray-50">
                    <h3 class="text-lg font-bold text-gray-800">${isEdit ? '상품 수정 (Edit)' : '상품 추가 (Add)'}</h3>
                    <button id="close-editor-btn" class="text-gray-400 hover:text-gray-600">
                        <span class="material-symbols-outlined">close</span>
                    </button>
                </div>

                <!-- Body (Scrollable) -->
                <div class="p-6 overflow-y-auto space-y-5">
                    
                    <!-- Basic Info -->
                    <div class="grid grid-cols-2 gap-4">
                        <div class="col-span-2">
                             <label class="block text-xs font-bold text-gray-500 uppercase mb-1">고유 ID (Slug)</label>
                             <input type="text" id="editor-id" class="w-full border-gray-300 rounded-lg text-sm font-mono text-gray-600 bg-gray-50" value="${product?.id || ''}" ${isEdit ? 'disabled' : ''} placeholder="Auto-generated if empty">
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-gray-500 uppercase mb-1">상품명 (Name)</label>
                            <input type="text" id="editor-name" class="w-full border-gray-300 rounded-lg text-sm font-bold" value="${product?.name || ''}" placeholder="Main Title">
                        </div>
                         <div>
                            <label class="block text-xs font-bold text-gray-500 uppercase mb-1">부제 (Sub Name)</label>
                            <input type="text" id="editor-sub" class="w-full border-gray-300 rounded-lg text-sm" value="${product?.sub_name || ''}" placeholder="Description">
                        </div>
                    </div>

                    <!-- Economics -->
                    <div class="p-4 bg-indigo-50 rounded-xl border border-indigo-100 grid grid-cols-3 gap-4">
                         <div>
                            <label class="block text-xs font-bold text-indigo-800 uppercase mb-1">가격 (KRW)</label>
                            <input type="number" id="editor-price" class="w-full border-indigo-200 rounded-lg text-sm font-bold text-right" value="${product?.price || ''}">
                        </div>
                         <div>
                            <label class="block text-xs font-bold text-indigo-800 uppercase mb-1">지급 스타</label>
                            <input type="number" id="editor-amount" class="w-full border-indigo-200 rounded-lg text-sm font-bold text-indigo-600 text-right" value="${product?.amount || ''}">
                        </div>
                         <div>
                            <label class="block text-xs font-bold text-indigo-800 uppercase mb-1">보너스 (%)</label>
                            <input type="number" id="editor-rate" class="w-full border-indigo-200 rounded-lg text-sm font-bold text-green-600 text-right" value="${product?.bonus_rate || 0}">
                        </div>
                    </div>

                    <!-- Visuals -->
                    <div class="grid grid-cols-2 gap-4">
                        <div>
                            <label class="block text-xs font-bold text-gray-500 uppercase mb-1">배지 (Badge)</label>
                            <input type="text" id="editor-badge" class="w-full border-gray-300 rounded-lg text-sm" value="${product?.badge_text || ''}" placeholder="ex: BEST, EVENT">
                        </div>
                         <div>
                            <label class="block text-xs font-bold text-gray-500 uppercase mb-1">테마 색상</label>
                            <select id="editor-color" class="w-full border-gray-300 rounded-lg text-sm">
                                <option value="gray" ${product?.theme_color === 'gray' ? 'selected' : ''}>Gray (Basic)</option>
                                <option value="blue" ${product?.theme_color === 'blue' ? 'selected' : ''}>Blue</option>
                                <option value="purple" ${product?.theme_color === 'purple' ? 'selected' : ''}>Purple</option>
                                <option value="silver" ${product?.theme_color === 'silver' ? 'selected' : ''}>Silver</option>
                                <option value="gold" ${product?.theme_color === 'gold' ? 'selected' : ''}>Gold</option>
                                <option value="red" ${product?.theme_color === 'red' ? 'selected' : ''}>Red (VVIP)</option>
                            </select>
                        </div>
                    </div>

                    <!-- Event Period -->
                    <div class="p-4 bg-yellow-50 rounded-xl border border-yellow-100">
                         <label class="block text-xs font-bold text-yellow-800 uppercase mb-2 flex items-center gap-1">
                            <span class="material-symbols-outlined text-sm">event</span>
                            이벤트 기간 설정 (Event Period)
                        </label>
                        <div class="grid grid-cols-2 gap-4">
                            <div>
                                <span class="text-[10px] text-gray-500 block mb-1">시작일 (Start Date + Time)</span>
                                <input type="datetime-local" id="editor-start" class="w-full border-yellow-200 rounded-lg text-sm bg-white" value="${formatIsoDate(product?.promotion_start)}">
                            </div>
                            <div>
                                <span class="text-[10px] text-gray-500 block mb-1">종료일 (End Date + Time)</span>
                                <input type="datetime-local" id="editor-end" class="w-full border-yellow-200 rounded-lg text-sm bg-white" value="${formatIsoDate(product?.promotion_end)}">
                            </div>
                        </div>
                        <p class="text-[10px] text-yellow-700 mt-2">* 기간을 설정하면 해당 기간에만 상품이 노출됩니다. (비워두면 상시 노출)</p>
                    </div>

                    <!-- Active -->
                    <div class="flex items-center gap-2">
                        <input type="checkbox" id="editor-active" class="rounded border-gray-300 text-indigo-600 w-4 h-4" ${product?.is_active !== false ? 'checked' : ''}>
                        <label for="editor-active" class="text-sm font-bold text-gray-700">판매 활성화 (Active)</label>
                    </div>
                </div>

                <!-- Footer -->
                <div class="p-4 border-t border-gray-100 bg-gray-50 flex justify-end gap-2">
                    <button id="cancel-editor" class="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-bold text-gray-600 hover:bg-gray-100">취소</button>
                    <button id="save-editor" class="px-6 py-2 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-md">저장하기</button>
                </div>
            </div>
        `;

        document.body.appendChild(overlay);

        // Events
        const close = () => overlay.remove();
        overlay.querySelector('#close-editor-btn').onclick = close;
        overlay.querySelector('#cancel-editor').onclick = close;

        overlay.querySelector('#save-editor').onclick = async () => {
            try {
                const id = document.getElementById('editor-id').value;
                const name = document.getElementById('editor-name').value;
                const sub = document.getElementById('editor-sub').value;
                const price = parseInt(document.getElementById('editor-price').value);
                const amount = parseInt(document.getElementById('editor-amount').value);
                const rate = parseInt(document.getElementById('editor-rate').value) || 0;
                const badge = document.getElementById('editor-badge').value;
                const color = document.getElementById('editor-color').value;
                const active = document.getElementById('editor-active').checked;

                const startVal = document.getElementById('editor-start').value;
                const endVal = document.getElementById('editor-end').value;

                if (!name || isNaN(price) || isNaN(amount)) {
                    throw new Error("상품명, 가격, 지급 스타는 필수입니다.");
                }

                // Construct payload
                const payload = {
                    id: product?.id || id || `prod_${Date.now()}`,
                    name, sub_name: sub,
                    price, amount, bonus_rate: rate,
                    badge_text: badge, theme_color: color,
                    is_active: active,
                    // Preserve existing order if edit, else 999 (will be sorted/dragged)
                    order_index: product?.order_index !== undefined ? product.order_index : 999
                };

                // Date logic
                if (startVal) payload.promotion_start = new Date(startVal).toISOString();
                else payload.promotion_start = null; // Clear if empty

                if (endVal) payload.promotion_end = new Date(endVal).toISOString();
                else payload.promotion_end = null;

                await AdminEconomyService.saveProduct(payload);
                await window.Modal.toast("저장되었습니다.");
                close();
                loadAll(); // Refresh Table

            } catch (e) {
                window.Modal.alert(e.message);
            }
        };
    };

    container.querySelector('#add-product-btn').onclick = () => openProductEditor();
    container.querySelector('#refresh-payment-btn').onclick = loadAll;

    // Reset Defaults Implementation
    container.querySelector('#reset-products-btn').onclick = async () => {
        if (await window.Modal.confirm(
            "모든 상품을 초기화하고 '기본 6종 상품'으로 덮어씌우시겠습니까?\n\n⚠️ 기존에 설정한 모든 상품 및 이벤트 기간이 삭제되며, 즉시 반영됩니다.",
            "기본값 복원 (DANGER)"
        )) {
            try {
                // 1. Delete All Existing
                const current = await AdminEconomyService.getProducts();
                for (const p of current) {
                    await AdminEconomyService.deleteProduct(p.id);
                }

                // 2. Insert Defaults
                for (const p of DEFAULT_PRODUCTS) {
                    await AdminEconomyService.saveProduct(p);
                }

                await window.Modal.toast("기본 상품으로 초기화되었습니다.");
                loadAll();
            } catch (e) {
                console.error(e);
                window.Modal.alert("초기화 실패: " + e.message);
            }
        }
    };

    // init
    loadAll();
};
